module.exports = __webpack_public_path__ + "static/media/springleafb.8ee559df.webp";